export default function VideoComponent({ data, style }) {
  const captionText = data?.caption?.[0]?.plain_text;

  return (
    <div key={data.id} style={{ width: "100%", ...style }}>
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <video
          controls
          autoPlay
          muted
          loop
          playsInline
          style={{ width: "100%", height: "auto", maxWidth: "100%", maxHeight: "100%" }}
        >
          <source src={data.file?.url} type="video/mp4" />
        </video>
      </div>
      {captionText && (
        <p className="caption" style={{ textAlign: "left", margin: "8px 0 0 0", width: "75%", marginLeft: "auto", marginRight: "auto" }}>
          {captionText}
        </p>
      )}
    </div>
  );
}
